function badgeTooltips () {
  const productBadges = [...document.querySelectorAll('.product-badge')];
  productBadges.forEach(badge => {
    badge.addEventListener('mouseover', () => {
      if(badge.src.includes("roundalls-01")) {
        tippy(badge, {
          followCursor: true,
          content: 'UK tanned and hand finished in Yorkshire',
        });
      }
      if(badge.src.includes("roundalls-02")) {
        tippy(badge, {
          followCursor: true,
          content: 'Wool from British sheep farmers',
        });
      }
      if(badge.src.includes("roundalls-03")) {
        tippy(badge, {
          followCursor: true,
          content: "Glencroft's own traceable yarn made from local Dales sheep",
        });
      }
    }) 
  });
}

badgeTooltips();

function alternateHeadings(headingContainer, textArray, textWrapper) {
  const randomNumber = Math.floor(Math.random() * textArray.length);
  if(textWrapper) {
    headingContainer.innerHTML = `<${textWrapper}>${textArray[randomNumber]}'</'${textWrapper}`;
  }
  if(!textWrapper) {
    headingContainer.textContent = textArray[randomNumber];
  }
}

function changeHomepageHeadingText() {
  const headingContainer = document.querySelector('.rich-text__blocks.section-template--15958509486141__rich_text_UGUz8x-padding');
  const textArray = [
    "'From Yorkshire's Heart to Your Home: Creating Beautiful, British countrywear with Honesty and Care since 1987.",
    "'Celebrating the Beauty & Community of the Yorkshire Dales One Cosy Knit at a Time",
    "'At Glencroft, we proudly support local sheep farmers, creating beautiful, sustainable knitwear that stands the test of time, from field to fashion.",
    "'Family-crafted country wear from the heart of the Yorkshire Dales - sustainable and timeless since 1987.",
    "'From our family to yours: beautiful British countrywear from the heart of the Yorkshire Dales, building community with every cosy knit since 1987.",
    "'From the Yorkshire Dales straight to your wardrobe, at Glencroft, we’ve been creating beautiful British countrywear and championing local sheep farmers since 1987."
  ];
  const textWrapper = 'h2';
  alternateHeadings(headingContainer, textArray, textWrapper);
}

window.onload = changeHomepageHeadingText


class CartNotification extends HTMLElement {
  clear(){
    this.classList.remove('active')
  }
  add(product_title,parsedState = null){
    this.classList.add('active')
    this.innerHTML = '<div>'+product_title+' added to cart!</div>'
    setTimeout(()=>{
      this.clear()
      setTimeout(()=>{
        this.innerHTML = ''
      },1000)
    },5000)
    if(parsedState != null){
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    }
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  
}

customElements.define('cart-notification', CartNotification);